import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  iconLeft?: ReactNode;
}

export default function Input({ label, error, iconLeft, id, className, ...props }: InputProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="space-y-1.5">
      <label htmlFor={inputId} className="block text-sm font-semibold text-slate-600 dark:text-slate-300">
        {label}
      </label>
      <div className="relative">
        {iconLeft ? <span className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-slate-400">{iconLeft}</span> : null}
        <input
          id={inputId}
          className={cn(
            'h-12 w-full rounded-xl border border-borderLight bg-cardLight px-4 text-sm text-textLight outline-none transition-all duration-200',
            'focus:border-primary focus:ring-4 focus:ring-primary/10 dark:border-borderDark dark:bg-cardDark dark:text-textDark dark:focus:border-cta dark:focus:ring-cta/15',
            iconLeft ? 'pl-10' : undefined,
            error && 'border-red-500 focus:border-red-500 dark:focus:border-red-400',
            className
          )}
          {...props}
        />
      </div>
      {error ? <p className="text-xs font-medium text-red-500">{error}</p> : null}
    </div>
  );
}
